import React from "react";

function Message(isVisible) {
  return (
    <>
      <span className={isVisible}>
        <pre id="message-text">{`

От 1 юли 2026 г. започва подаването на творби
за участие в Националния конкурс за поезия 
„Академик Николай Лилиев“.

Цел на конкурса:  
Да подпомага и популяризира поетичното 
творчество на автори над 18 години.

Организатори:  
Община Стара Загора
Дружество на писателите – Стара Загора
Фондация „Космос – Димитър Брацов“
Регионална библиотека „Захарий Княжески“

Партньори:  
НЧ „Николай Лилиев – 2005“
НЧ „Даскал Петър Иванов – 1988“
Списание „Птици в нощта“
Вестник „Литературен глас“

Условия за участие:  
– Конкурсът е анонимен и на свободна тема.
– Участници: автори, навършили 18 години.
– Допускат се само непубликувани творби 
към крайната дата за кандидатстване.
– Всеки автор изпраща до 3 поетични 
произведения на имейл: n-liliev@abv.bg  
– Краен срок: 11 септември 2026 г.

Изисквания към имейла:  
Заглавие: За конкурса Николай Лилиев – 2025  
Прикачени файлове (2):

файл с трите конкурсни стихотворения

файл с лични данни: три имена, 
дата на раждане, пощенски адрес, телефон

Личните данни се използват единствено за 
идентифициране и награждаване на победителите.

Съгласие:  
С изпращането на творбите авторите приемат 
имената и произведенията им да бъдат публикувани 
в социални мрежи, печатни и електронни медии, 
свързани с конкурса.

Не могат да участват:  
– членове на журито
– организаторите
– носители на първа награда от предишни издания

Награди:  
Първа награда – Награда на Кмета на Община Стара Загора
Втора награда – Награда на Фондация „Космос – Димитър Брацов“
Трета награда – Награда на НЧ „Николай Лилиев – 2005“

Поощрения:
Дружество на писателите – Стара Загора
НЧ „Даскал Петър Иванов – 1988“

Всички лауреати получават Почетна грамота.

Отчитане на резултатите:  
1 октомври – Ден на българската поезия.
Церемонията е част от Есенните 
литературни дни – Стара Загора 2025 г.

                `}</pre>
      </span>
    </>
  );
}

export default Message;
